/* istanbul ignore file */
import { Box } from '@mui/material';
import { CreateForm, TextInput } from 'framework/form';
import { usePrivilegedEmployeeId } from '../../privilegedAccessRouting';
import { PositionDropdown, EmployeeTypeDropdown, useEmployeeUrl } from 'domain/shared/employee';
import { useExternalAccountsService } from '../externalAccountsService';
import { InputTooltip, CreatePageLayout, FormSection, FormRow } from 'framework/ui/layout';
import useCreationResponseHandler from './accountsCreationResponseHandler';

const EmployeeAccountsCreationForm = () => {
  const employeeAlias = usePrivilegedEmployeeId()!;
  const { getProfileEditUrl } = useEmployeeUrl();
  const { createExternalAccounts, getEmployeeDataForForm, getEmployeeValidationSchema } = useExternalAccountsService();
  const { handleCreationResponse } = useCreationResponseHandler();

  const submitFormFunc = async (data: any) => {
    // eslint-disable-next-line no-param-reassign
    data.employeeId = employeeAlias;
    const response = await createExternalAccounts(data);
    handleCreationResponse(response, { employeeId: employeeAlias });
  };

  return (
    <CreateForm
      getDataFunc={() => getEmployeeDataForForm(employeeAlias)}
      submitFormFunc={submitFormFunc}
      afterSubmit={{
        execute: () => {},
      }}
      getValidationSchemaFunc={getEmployeeValidationSchema}
    >
      <CreatePageLayout title="Create: Azure and Redmine accounts">
        <FormSection title="Worker account information">
          <FormRow>
            <TextInput label="First name" source="firstNameEn" disabled />
            <TextInput label="Last name" source="lastNameEn" disabled />
            <TextInput label="Syberry email" source="workingEmail" />
          </FormRow>
          <FormRow>
            <EmployeeTypeDropdown label="Type" source="employeeType" disabled />
            <PositionDropdown label="Position" source="positionId" disabled isRequired />
            <TextInput label="Azure ID" source="azureId" disabled />
          </FormRow>
          <FormRow>
            <TextInput label="Identity document number (last 4 digits)" source="privateNotePassword" disabled />
          </FormRow>
          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <a href={getProfileEditUrl(employeeAlias)} target="_blank" rel="noreferrer">
              Open worker profile
            </a>
            <InputTooltip
              message="Reload page to get profile changes"
              source=""
              size="small"
              sx={{ marginLeft: '10px' }}
            />
          </Box>
        </FormSection>
      </CreatePageLayout>
    </CreateForm>
  );
};

export default EmployeeAccountsCreationForm;
